module.exports = __webpack_public_path__ + "static/media/24UHCHR9.b9176b8f.jpg";